<template>
	<div class="box container-fluid d-flex align-items-center">
		<sandwich_mobile_menu />
		<div class="d-flex align-items-center gap-5">
            <div v-if="auth_user.user_logged_in" class="text-center">
                <span class="subtenant-name">
                    {{ auth_user.subtenant_apelido }}
                </span>
                <p
                    v-if="menuStore().datetime"
                    class="fw-bold m-0">
                    {{ menuStore().datetime }}
                </p>
            </div>
            <div v-if="auth_user.user_logged_in">
                <user_toolbar_menu />
            </div>
            <a class="btn btn-outline botao-sair" @click="logout()">Sair</a>
        </div>
	</div>
</template>

<script setup lang="ts">
	import user_toolbar_menu from './user_toolbar_menu.vue';
	import sandwich_mobile_menu from './sandwich_mobile_menu.vue';
	import { usePage } from '@inertiajs/vue3';
	import { AuthUser } from '../../Interfaces/AuthUser';
	import request_photo from '../../utils/request_photo';
    import { menuStore } from '../../stores/menu';
	import axios from 'axios';
	import Swal from 'sweetalert2';

    const auth_user = usePage().props?.auth_user as AuthUser;

	const is_login = false;
	async function logout() {
		if (auth_user.user_role === 3) {			
			try {
				const response = await axios.get('/dashboard/check-active-class-status');
				const { is_in_class, is_first_license_course, has_finished_close_photo } = response.data;
				
				if (is_in_class && is_first_license_course && !has_finished_close_photo) {
					const result = await Swal.fire({
						title: 'Atenção!',
						html: 'Você ainda está em aula do curso de primeira habilitação e não finalizou a foto de fechamento.<br><br>Deseja realmente sair?',
						icon: 'warning',
						showCancelButton: true,
						confirmButtonText: 'Sim, sair mesmo assim',
						cancelButtonText: 'Cancelar',
						confirmButtonColor: '#ff662a',
						cancelButtonColor: '#6c757d'
					});

					if (!result.isConfirmed) {
						return;
					}
				}

				request_photo(is_login);
			} catch (error) {
				console.error('Erro ao verificar status da aula:', error);				
				request_photo(is_login);
			}
		} else {
			window.location.href = '/logout';
		}
	}
</script>

<style scoped>
	.subtenant-name {
		font-weight: 500;
	}
	.box {
		height: 65px;
		background-color: #fff;
		justify-content: end;
	}
	.botao-sair {
		border-color: #ff662a;
		color: #ff662a;
	}
	.botao-sair:hover {
		color: black;
	}

	.sandwich-button {
		display: none;
	}

	@media screen and (max-width: 768px) {
		.box {
			justify-content: space-between;
		}

		.sandwich-button {
			display: flex;
		}
	}
</style>
